import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Language } from '../../interfaces/language.model';
import { StorageProvider } from '../../providers/storage/storage';
import { LanguageProvider } from '../../providers/language/language';
import { FilterProvider } from '../../providers/filter/filter';

@Component({
  selector: 'language-filter',
  templateUrl: 'language-filter.html'
})
export class LanguageFilterComponent {

  languages: Language[];
  @Input() selectedLanguage: Language;
  @Output() changed: EventEmitter<any> = new EventEmitter();

  constructor(public storageService: StorageProvider, public filterService: FilterProvider, public languageService: LanguageProvider) {
    this.languages = this.languageService.getAllLanguages();
  }

  languageChanged(lang){
    this.languageService.setSelectedLang(lang.LanguageCode).then(() => {
      this.filterService.filterAssets().then(() => this.changed.emit(null));
    });
  }

}



// WEBPACK FOOTER //
// ./src/components/language-filter/language-filter.ts